function convertToSrcSet (images = []) {
  return images
    .map(image => `${image.imageUrl || image.url || image.src} ${image.width || image.pixelWidth}w`)
    .join(', ')
}

module.exports = convertToSrcSet
